import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response, ResponseContentType } from '@angular/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';



import { CommonService } from './common.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BindComponentService } from '../utils/bind.component.service';
/**
 * 
 * @version $Id: offer.banner.service.ts 81701 2018-03-08 23:46:04Z thiago.h.neri $
 */

@Injectable()
export class OfferBannerService extends CommonService  {

  private localURL: string;

  constructor(public http: Http,public modalService: NgbModal,public bindComponent: BindComponentService) {
    super(http, modalService, bindComponent);
    this.localURL = '/Portal/offerBanner';  
  }

  public getOffers() {
    return this.convertResponse(this.httpGet(this.localURL+ '?action=getAllOffers'));
  }

}


// WEBPACK FOOTER //
// ./src/app/services/offer.banner.service.ts